import { BASE_URL } from "../BaseUrl.js"; 
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient")
  if (token) {
    config.headers.Authorization =  `Bearer ${token}`;
  } else {
    config.headers.Authorization =  null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode")
  if (codeEntite) {
    config.headers['ref_entity'] = `client_${codeEntite}`;
  } else {
    config.headers['ref_entity'] =  null;
  }

  // const sousEntiteId = localStorage.getItem("sousEntiteId")
  // if (sousEntiteId) {
  //   config.headers['etablissementId'] = `${sousEntiteId}`;
  // } else {
  //   config.headers['etablissementId'] =  null;
  // }

  return config;
});

const customHeader = {
  'etablissementId': localStorage.getItem("sousEntiteId") ? localStorage.getItem("sousEntiteId") : null,
};

export const getListeAnneeAcademiquePagination = async (page, size, param = "") => {
  return await axios.get(
    BASE_URL(`etablissement/listeanneesacademiques/paginate?page=${page}&size=${size}&param=${param}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getListeAnneeAcademique = async () => {
  return await axios.get(
    BASE_URL(`etablissement/listeanneesacademiques`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const getListeAnneeAcademiqueDispo = async () => {
  return await axios.get(
    BASE_URL(`etablissement/listeanneesacademiquesnonassocies`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const ajoutAnneeAcademique = async (values) => {
  return await axios.post(
    BASE_URL("etablissement/enregisteranneeacademique"),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const deleteAnneeAcademique = async (id) => {
  return await axios.delete(
    BASE_URL(`etablissement/supprimeranneeacademique/${id}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const changeEtatAnneeAcademique = async (id) => {
  return await axios.post(
    BASE_URL(`etablissement/changeretatanneeacademique/${id}`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};
